export const city = [
    {
      number: 'CE100',
      hasModel: false,
    },
    {
      number: 'CE101',
      hasModel: false,
    },
    {
      number: 'CE102',
      hasModel: false,
    },
    {
      number: 'CE103',
      hasModel: false,
    },
    {
      number: 'CE104',
      hasModel: false,
    },
    {
      number: 'CE105',
      hasModel: false,
    },
    {
      number: 'CE106',
      hasModel: false,
    },
    {
      number: 'CE107',
      hasModel: false,
    },
    {
      number: 'CE108',
      hasModel: false,
    },
    {
      number: 'CE109',
      hasModel: false,
    },
    {
      number: 'CE110',
      hasModel: false,
    },
    {
      number: 'CE111',
      hasModel: false,
    },
    {
      number: 'CE112',
      hasModel: false,
    },
    {
      number: 'CE113',
      hasModel: false,
    },
    {
      number: 'CE114',
      hasModel: false,
    },
    {
      number: 'CE115',
      hasModel: false,
    },
    {
      number: 'CE116',
      hasModel: false,
    },
    {
      number: 'CE117',
      hasModel: false,
    },
    {
      number: 'CE118',
      hasModel: false,
    },
    {
      number: 'CE119',
      hasModel: false,
    },
    {
      number: 'CE120',
      hasModel: false,
    },
    {
      number: 'CE121',
      hasModel: false,
    }
]